<table mat-table matSort matSortStart="desc" [dataSource]="eventsDynTable" matSortDisableClear="true" class="table-striped">
  <ng-container matColumnDef="View">
    <th mat-header-cell *matHeaderCellDef disableClear="true">{{"VIEW"|translate}}
    </th>
    <td mat-cell *matCellDef="let element" style="cursor: pointer" [ngClass]="element.rowClassByCategoryLimit">
      <button class="btn list-tools" (click)="onViewClick(element)">
        <fa-icon [icon]="faEye"></fa-icon>
      </button>
    </td>
  </ng-container>
  <ng-container matColumnDef="Start">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true">Start
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.rowClassByCategoryLimit">{{timestampToIsoDateString(element.Start, true)}}
    </td>
  </ng-container>
  <ng-container matColumnDef="End">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true">End
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.rowClassByCategoryLimit">{{timestampToIsoDateString(element.End, true)}}
    </td>
  </ng-container>
  <ng-container matColumnDef="Duration">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true">Duration
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.rowClassByCategoryLimit">{{element.Duration}}
    </td>
  </ng-container>
  <ng-container matColumnDef="ValStart">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true">ValStart
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.rowClassByCategoryLimit">
      {{roundedValue(element.ValStart)}}
    </td>
  </ng-container>
  <ng-container matColumnDef="ValEnd">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true">ValEnd
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.rowClassByCategoryLimit">
      {{roundedValue(element.ValEnd)}}
    </td>
  </ng-container>
  <ng-container matColumnDef="Gap">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true">Gap
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.rowClassByCategoryLimit">
      {{roundedValue(element.Gap)}}
    </td>
  </ng-container>
  <ng-container matColumnDef="ValMin">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true">ValMin
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.rowClassByCategoryLimit">
      {{roundedValue(element.ValMin)}}
    </td>
  </ng-container>
  <ng-container matColumnDef="ValMax">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true">ValMax
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.rowClassByCategoryLimit">
      {{roundedValue(element.ValMax)}}
    </td>
  </ng-container>
  <ng-container matColumnDef="Range">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true">Range
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.rowClassByCategoryLimit">
      {{roundedValue(element.Range)}}
    </td>
  </ng-container>
  <ng-container matColumnDef="Mean">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true">Mean
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.rowClassByCategoryLimit">
      {{roundedValue(element.Mean)}}
    </td>
  </ng-container>
  <ng-container matColumnDef="Median">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true">Median
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.rowClassByCategoryLimit">
      {{roundedValue(element.Median)}}
    </td>
  </ng-container>
  <div>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  </div>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>


<mat-paginator
  [pageSize]="10"
  [pageSizeOptions]="[10, 25, 50]">
</mat-paginator>
